"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "convert12to24", {
  enumerable: true,
  get: function get() {
    return _dates.convert12to24;
  }
});
Object.defineProperty(exports, "convert24to12", {
  enumerable: true,
  get: function get() {
    return _dates.convert24to12;
  }
});

var _dates = require("react-time-picker/dist/shared/dates");


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-datetime-picker/dist/shared/dates.js
// module id = 1740
// module chunks = 3